import {
  GridRowMutationAction,
  GridRowMutationRequest,
  GridRowMutationRequestKeys,
  GridRowMutationResponse,
} from './mutate-grid-resource-row.model';
import { getGridResourceIdBySupportingTableId } from '../reporting/grid-resource.model';
import { SupportingTableId } from '../reporting/supporting-table.model';

export enum SupportingTableRowMutationAction {
  Create = 'create',
  Update = 'update',
  Delete = 'delete',
}

export enum MutateSupportingTableRowRequestKeys {
  supportingTableId = 'supportingTableId',
  action = 'action',
  rowNumber = 'rowNumber',
  values = 'values',
}

export interface MutateSupportingTableRowRequest {
  [MutateSupportingTableRowRequestKeys.supportingTableId]: SupportingTableId;
  [MutateSupportingTableRowRequestKeys.action]: SupportingTableRowMutationAction;
  [MutateSupportingTableRowRequestKeys.rowNumber]?: number | null;
  [MutateSupportingTableRowRequestKeys.values]?: Record<string, unknown> | null;
}

export interface MutateSupportingTableRowResponse {
  rowNumber: number | null;
  row: Record<string, unknown> | null;
  recordsTotal: number;
}

export function mapSupportingTableMutationActionToGridMutationAction(
  action: SupportingTableRowMutationAction,
): GridRowMutationAction {
  switch (action) {
    case SupportingTableRowMutationAction.Create:
      return GridRowMutationAction.Create;
    case SupportingTableRowMutationAction.Update:
      return GridRowMutationAction.Update;
    case SupportingTableRowMutationAction.Delete:
      return GridRowMutationAction.Delete;
    default:
      return GridRowMutationAction.Update;
  }
}

export function mapGridMutationActionToSupportingTableMutationAction(
  action: GridRowMutationAction,
): SupportingTableRowMutationAction {
  switch (action) {
    case GridRowMutationAction.Create:
      return SupportingTableRowMutationAction.Create;
    case GridRowMutationAction.Update:
      return SupportingTableRowMutationAction.Update;
    case GridRowMutationAction.Delete:
      return SupportingTableRowMutationAction.Delete;
    default:
      return SupportingTableRowMutationAction.Update;
  }
}

export function mapSupportingTableMutationRequestToGridRowMutationRequest(
  request: MutateSupportingTableRowRequest,
): GridRowMutationRequest {
  return {
    [GridRowMutationRequestKeys.resourceId]: getGridResourceIdBySupportingTableId(
      request[MutateSupportingTableRowRequestKeys.supportingTableId],
    ),
    [GridRowMutationRequestKeys.action]: mapSupportingTableMutationActionToGridMutationAction(
      request[MutateSupportingTableRowRequestKeys.action],
    ),
    [GridRowMutationRequestKeys.rowKey]: request[MutateSupportingTableRowRequestKeys.rowNumber] ?? null,
    [GridRowMutationRequestKeys.values]: request[MutateSupportingTableRowRequestKeys.values] ?? null,
  };
}

export function mapGridRowMutationResponseToSupportingTableMutationResponse(
  response: GridRowMutationResponse,
): MutateSupportingTableRowResponse {
  const rowNumber = response.rowKey == null ? null : Number(response.rowKey);

  return {
    rowNumber: rowNumber != null && Number.isInteger(rowNumber) && rowNumber > 0 ? rowNumber : null,
    row: response.row,
    recordsTotal: response.recordsTotal,
  };
}
